module.exports = __webpack_public_path__ + "static/img/hh-understand.bbd079f5.png";